import angular from "angular";
import _ from "lodash";
import moment from "moment";
import htmlTemplate from "./sb_deliverable_overlay.html";
import ODataFilterFactory from "../../../../services/oDataService/odata_filter_factory.class";

export default angular
    .module("sbApp.sbDeliverableOverlay", ["sbApp.sbDeliverableDependencies"])
    .constant("DELIVERABLE_OVERLAY_TAB", {
        ACTIVITIES: 0,
        NOTES: 1,
        CHECKLISTS: 2,
        DEPENDENCIES: 3,
    })

    .directive("sbDeliverableOverlay", function DeliverableOverlayDirective() {
        "ngInject";
        return {
            restrict: "E",
            bindToController: true,
            controllerAs: "$ctrl",
            templateUrl: htmlTemplate,
            controller: DeliverableOverlayCtrl,
        };
    });

function DeliverableOverlayCtrl(
    $q,
    $scope,
    $translate,
    $window,
    $sbDetailsOverlay,
    Analytics,
    $state,
    $rootScope,
    EVENTS,
    $sbDialog,
    $mdDialog,
    $mdToast,
    DELIVERABLE_OVERLAY_TAB,
    ISSUE_REPORT_TYPE,
    loadingToast,
    $sbCurrentProject,
    $sbDetailsOverlayData,
    $sbIssueEditorService,
    $sbDeliverableJobsApi,
    $sbStateChangesApi,
    $sbNotesApi,
    $sbAdminActionConfirmDialog,
    $sbExternalService,
    $sbErrorPresenter,
    $sbTracking,
    $sbDeliverables,
    $sbMembership,
    $timeout,
    EnvironmentFlags
) {
    "ngInject";

    /////////////////////
    //
    //      Direct variables
    //
    /////////////////////

    var vm = this;

    var previousSelectedTab = 0;

    /////////////////////
    //
    //      SCOPE properties
    //
    /////////////////////

    vm.selectedTab = 0;
    vm.canGoBack = false;
    vm.closeOverlay = closeOverlay;
    vm.goBack = goBack;
    vm.data = $sbDetailsOverlayData.current;
    vm.isLoading = $sbDetailsOverlayData.loading;
    vm.EnvironmentFlags = EnvironmentFlags;
    vm.previousViewType = "";
    vm.isOverlayNarrow = false;
    vm.isChecklistFillerLoading = true;
    vm.highlightedNoteId = undefined;

    vm.assignProcessTo = onAssignProcess;
    vm.onStateChange = onStateChange;
    vm.onCreateNote = onCreateNote;
    vm.onPrintNotes = onPrintNotes;
    vm.onFillChecklist = onFillChecklist;
    vm.selectedTeamChange = selectedTeamChange;
    vm.onRequestActivityUpdate = onRequestActivityUpdate;
    vm.onResetActivity = onResetActivity;
    vm.onRevertChecklistSigning = onRevertChecklistSigning;

    vm.selectActivitiesTab = $sbTracking.detailsOverlay.tabs.openActivities;
    vm.selectNotesTab = $sbTracking.detailsOverlay.tabs.openNotes;

    /////////////////////
    //
    //      WATCHER
    //
    /////////////////////

    $scope.$on(EVENTS.DETAILS_OVERLAY_STATE_CHANGED, onOverlayStateChanged);
    $scope.$on(
        EVENTS.DETAILS_OVERLAY_NAVIGATION_STATE_CHANGED,
        onNavigationStateChanged
    );

    vm.canGoBack = $sbDetailsOverlay.getNavigationState().canGoBack;

    function onOverlayStateChanged($event, { current }) {
        vm.viewType = current.viewType;
        current.mode === "narrow"
            ? (vm.isOverlayNarrow = true)
            : (vm.isOverlayNarrow = false);

        if (!current.id) {
            $sbDetailsOverlayData.unset();
            return;
        }

        switch (current.viewType) {
            case "deliverable":
                vm.previousViewType = "deliverable";
                vm.highlightedNoteId = current.dataContext?.highlightedNoteId;
                openDeliverablePanel(
                    current.id,
                    current.selectedTab,
                    current.dataContext
                );
                break;
            case "structure":
                openStructurePanel(current.id);
                break;
            case "checklist-viewer":
                openChecklistPanel(current.id);
                break;
            case "checklist-filler":
                openChecklistFillerPanel(current.dataContext);
                break;
            case "activity":
                vm.previousViewType = "activity";
                openActivityPanel(current.id);
                break;
            case "activities":
                openActivitiesPanel(current.dataContext);
                break;
            default:
                throw new Error("Invalid view type");
        }
    }

    function onNavigationStateChanged($event, { current }) {
        vm.canGoBack = Boolean(current && current.canGoBack);
    }

    $rootScope.$on(
        EVENTS.NOTE_CHANGED,
        function ($event, changeEvent, deliverableId) {
            if (changeEvent.isCreateEvent()) {
                $sbDetailsOverlayData.handleNoteCreated(deliverableId);
            } else {
                $sbDetailsOverlayData.handleNoteModified(changeEvent.after);
            }
        }
    );

    $sbDeliverables.createChangeWatcherFor(
        [$sbDeliverables.DELIVERABLE_CHANGE_TYPES.BASELINE],
        function ($event, deliverable) {
            if ($sbDetailsOverlayData.isCurrent(deliverable.id)) {
                _handleDeliverableChange($event, deliverable);
            }
        }
    );

    $rootScope.$on(EVENTS.DELIVERABLE__DATA_CHANGED, _handleDeliverableChange);

    $scope.$watch("$ctrl.selectedTab", function () {
        if (vm.selectedTab !== previousSelectedTab) {
            var previous = previousSelectedTab;
            var current = vm.selectedTab;
            previousSelectedTab = current;
            $rootScope.$broadcast(
                EVENTS.DELIVERABLE_OVERLAY_SELECTED_TAB_DID_CHANGE,
                {
                    previousSelectedTab: previous,
                    currentSelectedTab: current,
                }
            );
        }
    });

    /////////////////////
    //
    //       IMPL
    //
    /////////////////////

    function closeOverlay() {
        $sbDetailsOverlay.close();
        vm.selectedTab = 0;
        vm.isChecklistFillerLoading = false;
        vm.checklistFillerContext = undefined;
    }

    function goBack() {
        if (!vm.canGoBack) {
            return;
        }

        $sbDetailsOverlay.goBack().catch(angular.noop);
    }

    function selectedTeamChange(team) {
        vm.data.selectedTeam = team;
    }

    function openActivityPanel(activityId) {
        vm.activityId = activityId;
        $timeout(() => {
            _setPanelInput(
                "sb-app-activity-details-panel",
                "activityId",
                activityId
            );
        });
    }

    function openActivitiesPanel(dataContext) {
        if (!dataContext) {
            return;
        }

        vm.activitiesDataContext = dataContext;
        $timeout(() => {
            _setPanelInput(
                "sb-app-activity-list",
                "navigationContext",
                dataContext
            );
            _setPanelInput("sb-app-activity-list", "canGoBack", vm.canGoBack);
        });
    }

    function openStructurePanel(structureId) {
        vm.structureId = structureId;

        $timeout(() => {
            _setPanelInput(
                "sb-app-structure-details-panel",
                "structureId",
                structureId
            );
        });
    }

    function _setPanelInput(panelElementId, inputName, inputValue) {
        const panelElement = document.getElementById(panelElementId);

        if (!panelElement) {
            return;
        }

        panelElement[inputName] = inputValue;
    }

    function openDeliverablePanel(
        deliverableId,
        selectedTab = DELIVERABLE_OVERLAY_TAB.ACTIVITIES,
        dataContext
    ) {
        vm.selectedTab = selectedTab;

        const hasTeamPreselection =
            dataContext && "selectedTeamId" in dataContext;
        const teamPreselection = hasTeamPreselection
            ? { teamId: dataContext.selectedTeamId }
            : undefined;

        const preselectTeam = () => {
            if (teamPreselection) {
                $sbDetailsOverlayData.selectTeam(teamPreselection.teamId);
            }
        };

        if ($sbDetailsOverlayData.isCurrent(deliverableId)) {
            preselectTeam();
            return;
        }

        $sbDetailsOverlayData
            .load(deliverableId)
            .then(preselectTeam)
            .catch($sbErrorPresenter.catch);
    }

    function openChecklistPanel(openToken) {
        const [deliverableId, activityId, checklistId] = openToken.split("/");
        let deliverableLoad;

        if (!$sbDetailsOverlayData.isCurrent(deliverableId)) {
            // fill in the deliverable already because it will show up on "close"
            vm.selectedTab = DELIVERABLE_OVERLAY_TAB.CHECKLISTS;
            deliverableLoad = $sbDetailsOverlayData.load(deliverableId);
        } else {
            deliverableLoad = $q.resolve();
        }

        vm.openChecklist = undefined;
        deliverableLoad
            .then(() =>
                $sbDetailsOverlayData.pickActivityChecklistFor(
                    deliverableId,
                    activityId,
                    Number.parseInt(checklistId, 10)
                )
            )
            .then((checklist) => {
                checklist.activity = vm.data.deliverable.find(activityId);
                return checklist;
            })
            .then((checklist) => {
                $scope.$applyAsync(() => {
                    vm.openChecklist = checklist;
                });
            })
            .catch($sbErrorPresenter.catch);
    }

    function openChecklistFillerPanel(dataContext) {
        if (!dataContext) {
            return;
        }

        const deliverableId = dataContext.deliverableId;

        const normalizedActivityState = normalizeStateToken(
            dataContext.activityState,
            dataContext.fromState
        );
        const normalizedToState =
            normalizeStateToken(dataContext.toState) ||
            deriveChecklistFillerToState(normalizedActivityState);

        if (!normalizedToState) {
            return;
        }

        vm.checklistFillerContext = undefined;
        vm.isChecklistFillerLoading = true;

        const minimumLoadingTime = $timeout(angular.noop, 200);

        const ensureDeliverableIsLoaded =
            deliverableId && !$sbDetailsOverlayData.isCurrent(deliverableId)
                ? $sbDetailsOverlayData
                      .load(deliverableId)
                      .catch($sbErrorPresenter.catch)
                : $q.resolve();

        $q.all([ensureDeliverableIsLoaded, minimumLoadingTime]).finally(() => {
            const deliverable = vm.data ? vm.data.deliverable : undefined;
            vm.checklistFillerContext = Object.assign({}, dataContext, {
                projectId:
                    dataContext.projectId || $sbCurrentProject.pick("id"),
                deliverableName:
                    dataContext.deliverableName ||
                    (deliverable ? deliverable.name : ""),
                structureId:
                    dataContext.structureId ||
                    (deliverable ? deliverable.structureId : undefined),
                approvalType: dataContext.approvalType,
                fromState: normalizedActivityState,
                toState: normalizedToState,
                isOpen: true,
            });

            vm.isChecklistFillerLoading = false;
        });
    }

    function normalizeStateToken(primaryValue, fallbackValue) {
        if (angular.isString(primaryValue)) {
            return primaryValue.toLowerCase();
        }

        if (angular.isString(fallbackValue)) {
            return fallbackValue.toLowerCase();
        }

        return undefined;
    }

    function deriveChecklistFillerToState(activityState) {
        switch (activityState) {
            case "not_started":
                return "started";
            case "started":
                return "done";
            case "waiting_for_confirmation":
                return "review_checklist";
            default:
                return undefined;
        }
    }

    /**
     * Trigger UI refresh in case that a deliverable property change occurred that is currently
     * displayed in this UI element.
     *
     * @param $event
     * @param {Object|String} identifier - something to identify a deliverable
     * @private
     */
    function _handleDeliverableChange($event, identifier) {
        if (angular.isObject(identifier)) {
            identifier = identifier.id || identifier.ID;
        }

        if ($sbDetailsOverlayData.isCurrent(identifier)) {
            $sbDetailsOverlayData
                .load(identifier)
                .catch($sbErrorPresenter.catch);
        }
    }

    function onAssignProcess($event, deliverable) {
        return $sbDialog
            .openAssignTemplateDialog($event)
            .then(({ selectedTemplate }) => {
                const busyWhileAssignDialog = $mdDialog
                    .busyIndication()
                    .title("DIALOG_MERGE_STRUCTURE_LOADING_TITLE")
                    .text("ACTION_ASSIGN_TEMPLATE_LOADING")
                    .allPromises([
                        $sbDeliverableJobsApi.createAssignProcessJob(
                            deliverable.projectId,
                            {
                                strategy:
                                    $sbDeliverableJobsApi.ASSIGN_STRATEGY
                                        .ASSOCIATE,
                                deliverable_set: [deliverable.id],
                                process_template_id: selectedTemplate.ID,
                            }
                        ),
                    ]);

                return $mdDialog.show(busyWhileAssignDialog).catch((err) => {
                    const isCanceled = _.isUndefined(err);
                    if (!isCanceled) {
                        $sbErrorPresenter.catch(err);
                    }
                });
            })
            .then(() => _handleDeliverableChange($event, deliverable));
    }

    function onFillChecklist(activity, fromState, toState) {
        Analytics.trackConversion("activity status changed");

        void $sbDetailsOverlay.toggle("checklist-filler", {
            id: `${vm.data.deliverable.id}/${activity.id}/${toState}`,
            projectId: activity.projectId,
            dataContext: {
                deliverableId: vm.data.deliverable.id,
                deliverableName: vm.data.deliverable.name,
                projectId: activity.projectId,
                activityId: activity.id,
                activityName: activity.name,
                approvalType: activity.approvalType,
                activityState: activity.state.current,
                fromState,
                toState,
            },
        });
    }

    function onRequestActivityUpdate(activity) {
        $sbTracking.detailsOverlay.activity.requestUpdate();

        let projectName = $sbCurrentProject.pick("name");
        let deliverableCode = vm.data.deliverable.code;
        let activityName = activity.name;
        let deliverableUrl = `${activity.projectId}/ngdeliverables?open=${vm.data.deliverable.id}`;
        let userName = $sbMembership.currentUser().displayName;

        var translations = $translate.instant(
            [
                "REQUEST_ACTIVITY_UPDATE_EMAIL_SUBJECT",
                "REQUEST_ACTIVITY_UPDATE_EMAIL_BODY",
            ],
            {
                projectName,
                deliverableCode,
                activityName,
                deliverableUrl,
                userName,
            }
        );

        $window.location.href =
            "mailto:?subject=" +
            encodeURIComponent(
                translations.REQUEST_ACTIVITY_UPDATE_EMAIL_SUBJECT
            ) +
            "&body=" +
            encodeURIComponent(translations.REQUEST_ACTIVITY_UPDATE_EMAIL_BODY);
    }

    function onResetActivity(activity) {
        const projectId = $sbCurrentProject.pick("id");

        return $sbAdminActionConfirmDialog
            .show({
                title: "RESET_ACTIVITY_TITLE",
                description: "RESET_ACTIVITY_DESCRIPTION",
                requiresConfirmWord: true,
            })
            .then((isAccept) => {
                if (!isAccept) {
                    return;
                }

                return $sbExternalService
                    .resetActivitiesJob(projectId, {
                        activity_ids: [activity.id],
                    })
                    .then(function () {
                        $sbTracking.detailsOverlay.activity.reset(
                            $state.current.gaPageTrack
                        );

                        $rootScope.$emit(EVENTS.DELIVERABLE__DATA_CHANGED, {
                            id: vm.data.deliverable.id,
                        });
                    });
            });
    }

    function onRevertChecklistSigning(activity) {
        const projectId = $sbCurrentProject.pick("id");

        return $sbAdminActionConfirmDialog
            .show({
                title: "REVERT_CHECKLIST_SIGNING_TITLE",
                description: "REVERT_CHECKLIST_SIGNING_DESCRIPTION",
                requiresConfirmWord: true,
                confirmLabel: "REVERT_CHECKLIST_SIGNING_CONFIRMATION",
                confirmWord: "REVERT",
            })
            .then((isAccept) => {
                if (!isAccept) {
                    return;
                }

                return $sbExternalService
                    .revertChecklistSigningJob(projectId, {
                        activity_ids: [activity.id],
                        revert_type: "OF_CONFIRMATION",
                    })
                    .then(function () {
                        $sbTracking.detailsOverlay.activity.revertChecklistSigning(
                            $state.current.gaPageTrack
                        );

                        $rootScope.$emit(EVENTS.DELIVERABLE__DATA_CHANGED, {
                            id: vm.data.deliverable.id,
                        });
                    });
            });
    }

    /**
     * Optimistic state change handler with rollback functionality.
     *
     * Emits 'COMPONENT_DETAIL__STATE_CHANGED' event with new state on successful state change.
     *
     * @param activity
     * @param toState
     *
     * @returns {Promise<undefined>}
     */
    function onStateChange(activity, toState) {
        Analytics.trackConversion("activity status changed");

        const fromState = activity.state.current;
        const overlayActivity = vm.data.deliverable.find(activity.id);

        if (fromState === toState) {
            return $q.resolve();
        }

        loadingToast.show("_UPDATING_STATUS");
        overlayActivity.setCurrentState(toState);
        activity.setCurrentState(toState);

        return $sbStateChangesApi
            .create(activity.id, {
                state: toState.toLowerCase(),
            })
            .then(function () {
                _showSuccessToast();

                $scope.$emit(
                    EVENTS.COMPONENT_DETAIL__STATE_CHANGED,
                    overlayActivity.id,
                    overlayActivity.state.current,
                    vm.data.deliverable.id
                );
            })
            .catch(function (error) {
                overlayActivity.setCurrentState(fromState);
                activity.setCurrentState(fromState);
                $sbErrorPresenter.catch(error);
            });
    }

    function onPrintNotes(component, note) {
        const issueCount = vm.data.notes.length;
        const filterFactory = new ODataFilterFactory();
        const filterDescription = [];
        let gaLabel = "Issues of deliverable";

        if (component) {
            filterFactory.eq("ROOT_COMPONENT_ID", component.id);
            filterDescription.push({
                key: $translate.instant("_DELIVERABLE"),
                value: component.name,
            });
        }

        if (note) {
            filterFactory.eq("ISSUE_ID", note.ISSUE_ID || note.id);
            gaLabel = "Single Issue";
        }

        $mdDialog.show(
            $mdDialog
                .issueReportDialog()
                .issueCount(issueCount)
                .choice({
                    key: ISSUE_REPORT_TYPE.NOTES_AND_IMAGES,
                    gaLabel,
                })
                .oDataFilter({
                    filter: filterFactory.get(),
                })
                .filterDescription(filterDescription)
        );
    }

    function onCreateNote(component) {
        $sbTracking.note.creation.start("Details Overlay");

        const isDeliverable = $sbDetailsOverlayData.isCurrent(component.id);

        const showDialog = isDeliverable
            ? $sbIssueEditorService.showForDeliverable(vm.data.teams)
            : $sbIssueEditorService.showForActivity(
                  component.assignedTeam,
                  vm.data.teams
              );

        return showDialog
            .then(function ({ note }) {
                return $sbNotesApi
                    .create(component.projectId, {
                        type: pickType(note),
                        text: note.text,
                        created: {
                            at: note.createTime
                                ? note.createTime.toISOString()
                                : moment().toISOString(),
                        },
                        note_template_id: note.noteTemplateId,
                        assigned_team_id: pickResponsibleTeam(note),
                        activity_id: isDeliverable ? undefined : component.id,
                        deliverable_id: isDeliverable
                            ? component.id
                            : undefined,
                        image_ids: note.getImages().map((image) => image.id),
                        attachment_ids: note
                            .getAttachments()
                            .map((attachment) => attachment.id),
                        confirmation_team_id: pickConfirmationTeam(note),
                    })
                    .then((noteResponse) => {
                        noteResponse.deliverable_id = vm.data.deliverable.id;

                        $sbDetailsOverlayData.notifyNoteAdded(
                            noteResponse.deliverable_id
                        );

                        return $sbTracking.note.creation.done(
                            "Details Overlay",
                            {
                                type: noteResponse.type,
                                photos: noteResponse.image_ids,
                                attachments: noteResponse.attachments,
                            }
                        );
                    });
            })
            .catch((err) => {
                if (err) {
                    throw err;
                }
            });
    }

    function pickType(note) {
        if (note.type === "claim") {
            return "quality_issue";
        } else {
            return note.type;
        }
    }

    function pickResponsibleTeam(note) {
        const team = _.get(note, "responsibleTeam.id");
        if (!_.isNil(team)) {
            return team;
        }
    }

    function pickConfirmationTeam(note) {
        const team = _.get(note, "confirmationTeam.id");
        if (!_.isNil(team)) {
            return team;
        }
    }

    function _showSuccessToast() {
        $mdToast.show(
            $mdToast
                .simple()
                .content("_STATUS_UPDATED")
                .hideDelay(2000)
                .position("top right")
        );
    }
}
